import { SVGProps } from 'react';

export function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 272 220"
      aria-hidden="true"
      {...props}
    >
      <defs>
        <linearGradient id="markflow-logo-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#d946ef" />
        </linearGradient>
      </defs>
      <g transform="translate(0,220) scale(0.1,-0.1)" stroke="none" fill="url(#markflow-logo-grad)">
        <path d="M555 1870 c-81 -40 -80 -32 -83 -493 l-3 -409 25 -41 c30 -51 310 -332 323 -324 5 3 10 140 12 314 1 169 4 309 6 311 2 3 69 -60 150 -139 l145 -142 143 139 c78 76 187 184 242 240 55 55 126 124 158 152 l59 52 283 0 283 0 90 173 c49 94 86 176 82 180 -4 4 -195 6 -426 5 -492 -3 -441 9 -597 -143 -56 -55 -150 -146 -208 -203 l-106 -103 -211 211 c-250 250 -276 265 -367 220z" />
        <path d="M1663 1208 c-173 -166 -263 -259 -280 -290 -16 -30 -18 -68 -21 -428 l-2 -395 159 160 c87 88 165 169 173 180 9 15 14 80 18 245 l5 225 142 5 c78 3 145 8 149 12 14 14 171 338 166 343 -3 3 -104 5 -225 5 l-219 0 -65 -62z" />
      </g>
    </svg>
  );
}
